export default [
	{  //任务类型列表
		path: 'task/type',
		name: 'm_collab_task_type',
		meta: {
			templateManage: {
				workType: 50,
				print: 'b_collabtasktype_printtemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/collab/collab_task_type_list.vue')
	},
	{  //协同任务列表
		path: 'task',
		name: 'm_collab_task',
		meta: {
			templateManage: {
				workType: 51,
				print: 'b_collabtask_printtemplate',
				export: 'b_collabtask_exporttemplate'
			},
			appView: {
				viewId: '90036',
				auth: 'b_collabtask_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/collab/collab_task_list.vue')
	}
];
